import { Select } from '@insly/qmt-reactjs-ui-lib';
import styled from 'styled-components';

export const SelectBranch = styled(Select)`
  width: 300px;
  .qmt-ui-dropdown__drop {
    max-height: calc(42px * 8); //8 rows
  }
`;
